import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'unsupported-browser',
  templateUrl: './unsupported-browser.component.html',
  styleUrls: ['./unsupported-browser.component.sass']
})
export class UnsupportedBrowserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
